import React, { useState } from "react";
import Select from "react-select";
import fetchProducts from "./components/fetchProducts";
import "./style.css";
import { toast } from "react-toastify";

const orgOptions = [
  { value: "jinkies", label: "Oyebubbli" },
  { value: "wagg", label: "Wagg Electronics" },
  { value: "ranch", label: "Jaipuran" },
  { value: "quilaD", label: "Quila Decor" },
  { value: "carens", label: "Carens" },
  { value: "seltous", label: "The Rareman" },
  { value: "vexora", label: "Shopping Gora" },
  { value: "wavepay", label: "Shop Gudies" },
];

const GenerateProducts = () => {
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [amount, setAmount] = useState("");
  const [result, setResult] = useState(null);

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setAmount(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedOrg || !amount) {
      toast.error("Please select organization and enter a valid amount.");
      return;
    }

    const numericAmount = parseFloat(amount);
    const response = await fetchProducts(selectedOrg.value, numericAmount);

    setResult(response);
    setSelectedOrg(null);
    setAmount("");
  };

  return (
    <>
      <div className="product-form-container">
        <h2>Get Product List</h2>
        <form onSubmit={handleSubmit}>
          <label className="gen-product-label">Organization</label>
          <Select
            options={orgOptions}
            value={selectedOrg}
            onChange={setSelectedOrg}
            className="gen-prod-select-field"
            placeholder="Select organization..."
          />

          <label className="gen-product-label">Amount</label>
          <input
            type="text"
            value={amount}
            onChange={handleAmountChange}
            className="amount-input"
            placeholder="Enter amount"
          />

          <button type="submit" className="gen-prod-submit-button">
            Submit
          </button>
        </form>
      </div>
      {result && (
        <div className="gen-prod-result-container">
          <h3>Product List</h3>
          <ul className="gen-product-list">
            {result.products.map((p, idx) => (
              <li key={idx}>
                <span className="product-name">{p.name}</span>
                <span className="product-amount">₹{p.amount}</span>
              </li>
            ))}
          </ul>

          <div className="gen-prod-summary">
            <p>
              <strong>Taxable Amount:</strong> ₹{result.taxableAmount}
            </p>
            <p>
              <strong>GST (18%):</strong> ₹{result.gstValue}
            </p>
            <p>
              <strong>Discount Applied:</strong> ₹{result.discount}
            </p>
            <p>
              <strong>Product Total:</strong> ₹{result.productTotal}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default GenerateProducts;
